import React, { useContext } from 'react'
import styled, { css } from 'styled-components'
import isMobileCheck from 'is-mobile'
import SectionHeader, { SectionHeaderWithSeeAll } from 'shared/components/section-header'
import { IContentBlock } from '../types'
import { ContentBlockContext } from './../context'
import { Container as BlockLabel } from './block-label'
import Block from './block'

const IS_MOBILE = isMobileCheck()
const BLOCK_MARGIN = IS_MOBILE ? 6 : 12
const DEFAULT_BLOCK_WIDTH = 160

const Container = styled.div`
    display: flex;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
`

const BlockWrapper = styled.div<{ hasLabelDim: boolean }>`
    ${props =>
        props.hasLabelDim &&
        css`
            &:nth-child(6n + 1) ${BlockLabel}:before {
                background: rgba(0, 0, 0, 0.1);
            }
            &:nth-child(6n + 2) ${BlockLabel}:before, &:nth-child(6n + 6) ${BlockLabel}:before {
                background: rgba(0, 0, 0, 0.2);
            }
            &:nth-child(6n + 3) ${BlockLabel}:before, &:nth-child(6n + 5) ${BlockLabel}:before {
                background: rgba(0, 0, 0, 0.3);
            }
            &:nth-child(6n + 4) ${BlockLabel}:before {
                background: rgba(0, 0, 0, 0.4);
            }
        `}
`

type Props = {
    blocks: IContentBlock[]
    className?: string
}

const ContentBlocks = ({ blocks = [], className }: Props) => {
    const { title, width, seeAllUrl } = useContext(ContentBlockContext)
    const contentWidth = width ? width - BLOCK_MARGIN * (blocks.length - 1) : 0
    const blockWidth = contentWidth ? contentWidth / blocks.length : DEFAULT_BLOCK_WIDTH
    return (
        <div className={className}>
            {seeAllUrl ? <SectionHeaderWithSeeAll label={title} url={seeAllUrl} /> : <SectionHeader label={title} />}
            <Container>
                {blocks.map((data, i) => (
                    <BlockWrapper
                        key={data.id}
                        hasLabelDim={!!width}
                        style={{ marginRight: i < blocks.length - 1 ? BLOCK_MARGIN : 0 }}
                    >
                        <Block data={data} width={blockWidth} />
                    </BlockWrapper>
                ))}
            </Container>
        </div>
    )
}

export default ContentBlocks
